module.exports = __webpack_public_path__ + "img/dining-table.e28ef1ef.webp";